import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import loadable from '@loadable/component';

import { concatUrl } from 'modules/shared/utils';
import { SubRouterProps } from 'modules/shared/types';
import { Switch } from 'modules/shared/components';
import { buildRoutesFromStructure } from 'modules/shared-navigation';
import { UniverseTypeValues } from 'modules/shared/models';

import { ContentSelector } from './components';

export const Router: React.FC<SubRouterProps> = (props: SubRouterProps) => {
    const { navigationTree, sourceStructureNode } = props;

    if (!sourceStructureNode || !sourceStructureNode.nodes || sourceStructureNode.nodes.length === 0) {
        return <React.Fragment />;
    }

    return (
        <Switch>
            <Route
                exact
                path={concatUrl([navigationTree.path, '/type/:universeType'])}
                render={({ match }) => {
                    /* webpackChunkName: "list-choice-alt.page" */
                    const ListChoiceAlt = loadable(() => import('../../pages/list-choice-alt/list-choice-alt.page'));
                    return (
                        <ListChoiceAlt
                            filterParams={[{ key: 'universeType', value: match.params.universeType || '' }]}
                            path={match.url}
                            parentNavigationTree={navigationTree}
                        />
                    );
                }}
            />
            <Route
                exact
                path={concatUrl([navigationTree.path, '/nom/:universeType'])}
                render={({ match }) => {
                    /* webpackChunkName: "list-name-page" */
                    const ListOrganiser = loadable(() => import('../../pages/list-organiser/list-organiser-page'));
                    return (
                        <ListOrganiser
                            filterParams={[{ key: 'universeType', value: match.params.universeType || '' }]}
                            path={match.url}
                            parentNavigationTree={navigationTree}
                        />
                    );
                }}
            />
            <Route
                exact
                path={concatUrl([navigationTree.path, '/creation/:universeType'])}
                render={({ match }) => {
                    /* webpackChunkName: "list-creation-page" */
                    const ListCreation = loadable(() => import('../../pages/list-creation/list-creation-page'));
                    const universeType = match.params.universeType || '';
                    const universeId = UniverseTypeValues.getIntByString(universeType);
                    if (!universeId) {
                        return <Redirect to="/not-found" />;
                    }
                    return (
                        <ListCreation
                            filterParams={[{ key: 'universeType', value: universeType }]}
                            universeId={universeId}
                            path={match.url}
                            parentNavigationTree={navigationTree}
                        />
                    );
                }}
            />
            <Route
                exact
                path={concatUrl([navigationTree.path, '/confirmation/:universeType'])}
                render={({ match }) => {
                    /* webpackChunkName: "list-confirmation-page" */
                    const ListConfirmation = loadable(() =>
                        import('../../pages/list-confirmation/list-confirmation-page'),
                    );
                    return (
                        <ListConfirmation
                            filterParams={[{ key: 'universeType', value: match.params.universeType || '' }]}
                            path={match.url}
                            parentNavigationTree={navigationTree}
                        />
                    );
                }}
            />
            {buildRoutesFromStructure(
                ContentSelector,
                sourceStructureNode ? sourceStructureNode.nodes : [],
                navigationTree,
            )}
        </Switch>
    );
};
